import * as ng from 'angular';

export const StSearch = ($timeout: ng.ITimeoutService) => (<angular.IDirective>{

    replace: true,
    require: '^stTable',
    scope: {
        predicate: '=?stSearch'
    },
    link: (scope: any, element: any, attr, ctrl: any) => {
        let tableCtrl = ctrl;
        let promise = null;
        let throttle = attr.stDelay || 400;

        scope.$watch('predicate', (newValue, oldValue) => {
            if (newValue !== oldValue) {
                ctrl.tableState().search = {};
                tableCtrl.search(element[0].value || '', newValue);
            }
        });

        // table state -> view
        scope.$watch(() => {
            return ctrl.tableState().search;
        }, (newValue, oldValue) => {
            let predicateExpression = scope.predicate || '$';
            if (newValue.predicateObject && newValue.predicateObject[predicateExpression] !== element[0].value) {
                element[0].value = newValue.predicateObject[predicateExpression] || '';
            }
        }, true);

        // view -> table state
        element.bind('input', (evt) => {
            evt = evt.originalEvent || evt;
            if (promise !== null) {
                $timeout.cancel(promise);
            }
            promise = $timeout(() => {
                tableCtrl.search(evt.target.value, scope.predicate || '');
                promise = null;
            }, throttle);
        });
    }
});

StSearch.$inject = ['$timeout'];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/third/smart-table/st-search/st-search.directive.ts